import { render, staticRenderFns } from "./distanced_household_allowances.vue?vue&type=template&id=368b4b55"
import script from "./distanced_household_allowances.vue?vue&type=script&lang=js"
export * from "./distanced_household_allowances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports